module.exports = __webpack_public_path__ + "img/ic-tick-green.23e48bcc.svg";